export const currencyRelatedFields = {
  'CURRENCY_BU-CURRENCY':  ['CURRENCY_CFG-TEXT', 'CURRENCY_CFG-NOOFDECIMAL', 'CURRENCY_CFG-CALNAME'],
  'CURRENCY_BU-DEFAULTNOSTROACC': ['ACCOUNTS-ACC_ALIAS'],
  'ACCOUNTS-V_SEIZE_FUNDS_SUSPENSE_ACC_NO': ['CURRENCY_BU-SEIZE_FUNDS_SUSPENSE_ACC_UID']
}
